import moment from 'moment'
import { faArrowLeft, faArrowRight } from '@fortawesome/pro-light-svg-icons'
import { selectPayrollByUuid } from '../../payroll.selectors'
import { PaymentOverview } from './PayrollOverview'
import { PayrollDetails } from './PayrollDetails'
import { PayrollHeader } from './PayrollHeader'
import { Button, Icon, Separator, Text } from '@/ui'
import { useReselector } from '@/utils/sharedHooks'
import { PayrollError } from '../../PayrollError'
import { PUT_PAYROLL_SUBMIT_KEY } from '../../payrollActions'
import { DATE_FORMATS } from '@/utils/dateHelpers'
import { TypographyStyles } from '@/styles'

export const PayrollReviewAndSubmitTab = ({
  goForward,
  goBack,
  uuid,
}: {
  goForward: () => void
  goBack: () => void
  uuid: string
}) => {
  const upcomingPayroll = useReselector(selectPayrollByUuid, uuid)

  if (!upcomingPayroll) {
    return null
  }

  return (
    <div className="flex flex-col gap-6">
      <PayrollHeader upcomingPayroll={upcomingPayroll} currentTab={2} />
      <Text variant={TypographyStyles.H1}>Review and Submit Payroll</Text>
      <Text variant={TypographyStyles.H3}>
        Please take a moment to review the following:
      </Text>

      <PaymentOverview payroll={upcomingPayroll} />

      <div className="pl-5">
        <Text variant={TypographyStyles.BODY_MD}>
          Funds will be withdrawn from your practice&apos;s bank account on{' '}
          <b>
            {moment(upcomingPayroll.payroll_deadline).format(
              DATE_FORMATS.DAY_OF_WEEK_DAY_MONTH
            )}
          </b>
          <br />
          If you submit this payroll by 3:30pm PT on{' '}
          <b>
            {moment(upcomingPayroll.payroll_deadline).format(
              DATE_FORMATS.DAY_OF_WEEK_DAY_MONTH
            )}
          </b>
          , your employees will be paid by{' '}
          <b>
            {moment(upcomingPayroll.check_date).format(
              DATE_FORMATS.DAY_OF_WEEK_DAY_MONTH
            )}
          </b>
        </Text>
      </div>

      <PayrollError fetchKey={PUT_PAYROLL_SUBMIT_KEY} />

      <div className="flex flex-col md:flex-row justify-between items-center gap-4">
        <div className="w-full md:w-1/4">
          <Button onClick={goBack} variant="secondary" className="w-full">
            <Icon icon={faArrowLeft} className="mr-2" />
            Back
          </Button>
        </div>
        <div className="hidden md:block md:w-1/2" />
        <div className="w-full md:w-1/4">
          <Button onClick={goForward} className="w-full">
            Run Payroll <Icon icon={faArrowRight} className="ml-2" />
          </Button>
        </div>
      </div>

      <Separator />

      <PayrollDetails uuid={uuid} />
    </div>
  )
}
